// extracted by mini-css-extract-plugin
export default {"container":"team-members-Member__container--DJ2q4","name":"team-members-Member__name--pD8Sm"};